module.exports = __webpack_public_path__ + "img/carter-profilePix.447216f2.jpg";